/*
  ELL221026: cart drawer campaign helpers.
  - sections(items): called by assets/cart-drawer.js before the drawer template is built.
    Puts the campaign ("Buy 2 Get 1 Free") lines first with a title and a buy-more message,
    then the other lines with their own title. Without a campaign line, the list does not change.
    The copy comes from the data attributes on #CartContainer (snippets/cart_drawer.liquid).
  - update(cart): called after the drawer template is built, before the carousel starts.
    Keeps the campaign carousel ("Great for gifting season") when a cart product has the campaign tag,
    else keeps the default carousel. The other carousel is removed, so only one carousel starts.
  - cart.js has no product tags, so the tags come from /products/<handle>.js and are kept in sessionStorage.
    When new tags change the sections or the carousel, the drawer is built again.
*/
(function () {
  var STORAGE_KEY = 'campaignUpsellTags';
  var cache = {};
  var cacheTag = null;

  function getData() {
    var container = document.getElementById('CartContainer');
    return container ? container.dataset : {};
  }

  function getTag() {
    return (getData().campaignTag || '').toLowerCase();
  }

  function readCache(tag) {
    if (cacheTag === tag) return;
    cacheTag = tag;
    cache = {};
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (stored && stored.tag === tag && stored.handles) cache = stored.handles;
    } catch (e) {}
  }

  function writeCache() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ tag: cacheTag, handles: cache }));
    } catch (e) {}
  }

  function fetchTags(handle, tag) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : { tags: [] }; })
      .then(function (product) {
        cache[handle] = (product.tags || []).some(function (t) { return String(t).toLowerCase() === tag; });
      })
      .catch(function () { cache[handle] = false; });
  }

  function campaignHandles(handles) {
    return handles.filter(function (handle) { return cache[handle] === true; });
  }

  // Buy-more message for the campaign section: 3 campaign items give 1 free
  function promoText(data, qty) {
    var rest = qty % 3;
    if (rest === 1) return data.campaignPromoTwo || '';
    if (rest === 2) return data.campaignPromoOne || '';
    return (data.campaignPromoDone || '').replace('[count]', Math.floor(qty / 3));
  }

  function sections(items) {
    var tag = getTag();
    if (!tag || !items || !items.length) return items;
    readCache(tag);
    var data = getData();
    var promo = [];
    var other = [];
    var qty = 0;
    items.forEach(function (item) {
      if (!item.gwp && item.handle && cache[item.handle] === true) {
        promo.push(item);
        qty += item.itemQty || 0;
      } else {
        other.push(item);
      }
    });
    if (!promo.length) return items;
    promo[0].section = {
      type: 'promo',
      title: data.campaignPromoTitle || '',
      text: promoText(data, qty),
      link: data.campaignPromoLink || '',
      url: data.campaignPromoUrl || ''
    };
    if (other.length) {
      other[0].section = { type: 'other', title: data.campaignOtherTitle || '' };
    }
    return promo.concat(other);
  }

  function update(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart) return;
    var tag = getTag();
    if (!tag) return;
    readCache(tag);

    var handles = [];
    cart.items.forEach(function (item) {
      var isGwp = item.properties && item.properties._gwp;
      if (!isGwp && item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });

    var before = campaignHandles(handles).join(',');
    var campaign = drawer.querySelector('[data-cart-upsell="campaign"]');
    var fallback = drawer.querySelector('[data-cart-upsell="default"]');
    if (campaign) {
      if (before) {
        campaign.hidden = false;
        if (fallback) fallback.remove();
      } else {
        campaign.remove();
      }
    }

    var unknown = handles.filter(function (handle) { return !(handle in cache); });
    if (!unknown.length) return;
    Promise.all(unknown.map(function (handle) { return fetchTags(handle, tag); })).then(function () {
      writeCache();
      if (campaignHandles(handles).join(',') !== before && window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        window.ajaxCart.load();
      }
    });
  }

  window.campaignUpsell = { update: update, sections: sections };
})();
